module.exports = __webpack_public_path__ + "static/media/menuHours.42cf9fe8.svg";